export enum WidgetChatRoutes {
  root = 'widget/chat',
}
